import React from 'react';
import { PageHero, Section } from '../components/UI';
import styles from './Terms.module.css';

const SECTIONS = [
  {
    title: 'IT Training Services',
    body: [
      'Metawave Solutions provides IT training programs, courses, workshops, and related educational services. Course descriptions, technologies covered, training schedules, duration, fees, delivery methods, and other details may vary depending on the particular program.',
      'We reserve the right to update or modify course content where necessary to keep training material relevant to current technologies and industry practices.',
    ],
  },
  {
    title: 'Registration',
    body: [
      'Students are responsible for providing accurate and complete information during the registration process. Providing incorrect or misleading information may result in cancellation of registration or restriction of access to training services.',
      'Registration is confirmed only after completion of the applicable registration and payment requirements.',
    ],
  },
  {
    title: 'Course Fees and Payments',
    body: [
      'Students agree to pay the applicable course fees according to the payment terms provided by Metawave Solutions. Course fees, payment methods, and other applicable charges will be communicated before or during the registration process.',
      'Failure to complete payment may result in cancellation or suspension of access to the training program.',
    ],
  },
  {
    title: 'Attendance and Participation',
    body: [
      'Students are expected to attend scheduled training sessions and participate responsibly in the learning process. Metawave Solutions does not guarantee a particular academic, professional, employment, or financial outcome as a result of completing a training program.',
    ],
  },
  {
    title: 'Training Materials and Intellectual Property',
    body: [
      "All training materials, including presentations, documents, recordings, exercises, videos, software resources, logos, graphics, and other educational content provided by Metawave Solutions are protected by applicable intellectual-property laws.",
      "Training materials are provided for the student's personal educational use only. Students may not copy, reproduce, distribute, publish, resell, upload, or commercially exploit our training materials without prior written permission.",
    ],
  },
  {
    title: 'Online Training',
    body: [
      'For online training programs, students are responsible for having a suitable device, internet connection, required software, and a suitable environment to participate in the training.',
      "Metawave Solutions is not responsible for interruptions caused by the student's internet connection, device, software, or other circumstances outside our reasonable control.",
    ],
  },
  {
    title: 'Course Completion and Certificates',
    body: [
      'Where certificates are offered, eligibility may depend on the applicable course requirements, attendance, participation, assignments, assessments, or other conditions communicated for that particular program.',
      'Completion of a course or receipt of a certificate does not constitute a guarantee of employment or placement.',
    ],
  },
  {
    title: 'Prohibited Activities',
    body: [
      'Students must not misuse our website, training platforms, course materials, or services. Students must not attempt unauthorized access to systems, interfere with training sessions, impersonate another person, distribute unauthorized recordings or materials, or use our services for unlawful activities.',
    ],
  },
  {
    title: 'Website Content',
    body: [
      'We make reasonable efforts to ensure that information published on our website is accurate and current. However, course availability, schedules, instructors, technologies, fees, and other information may change without prior notice.',
    ],
  },
  {
    title: 'Third-Party Services',
    body: [
      'Our training programs may use third-party platforms, software, video-conferencing services, payment gateways, or other technology providers. Use of such services may also be subject to the terms and policies of the respective third-party providers.',
    ],
  },
  {
    title: 'Limitation of Liability',
    body: [
      'To the maximum extent permitted by applicable law, Metawave Solutions shall not be liable for indirect, incidental, or consequential losses arising from the use of our website or participation in our training programs, except where such limitation is not permitted by law.',
    ],
  },
  {
    title: 'Termination or Suspension',
    body: [
      "Metawave Solutions reserves the right to suspend or terminate a student's access to a training program or website where the student violates these Terms and Conditions, misuses training materials, engages in unlawful activity, or fails to comply with applicable payment requirements.",
    ],
  },
  {
    title: 'Changes to These Terms',
    body: [
      'Metawave Solutions may update these Terms and Conditions from time to time. Updated terms will be published on our website and will become effective from the stated effective date.',
    ],
  },
];

export default function Terms() {
  return (
    <>
      <PageHero
        tag="Legal"
        title="Terms & Conditions"
        subtitle="Please read these terms carefully before using our website or enrolling in our training programs."
      />

      <Section variant="paper">
        <div className={styles.container}>
          <p className={styles.intro}>
            Welcome to Metawave Solutions. These Terms and Conditions govern
            your use of www.metawavesolutions.com and your participation in
            the IT training programs and related services offered by
            Metawave Solutions.
          </p>
          <p className={styles.intro}>
            By accessing our website, submitting an enquiry, registering for
            a training program, or making a payment for our services, you
            agree to comply with these Terms and Conditions.
          </p>

          {SECTIONS.map((s, i) => (
            <div key={i} className={styles.block}>
              <h3 className={styles.blockTitle}>{s.title}</h3>
              {s.body.map((p, j) => (
                <p key={j} className={styles.bodyText}>
                  {p}
                </p>
              ))}
            </div>
          ))}

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>Contact Us</h3>
            <p className={styles.bodyText}>
              If you have questions regarding these Terms and Conditions or
              our IT training programs, please contact us through the
              contact details provided on our website.
            </p>
            <p className={styles.bodyText}>
              Website:{' '}
              <a href="https://www.metawavesolutions.com">
                www.metawavesolutions.com
              </a>
              <br />
              Email: <a href="mailto:info@metawavesolutions.com">info@metawavesolutions.com</a>
            </p>
          </div>
        </div>
      </Section>
    </>
  );
}
